import { render, staticRenderFns } from "./HouseFundsPerson.vue?vue&type=template&id=2959e30b&scoped=true"
import script from "./HouseFundsPerson.vue?vue&type=script&lang=js"
export * from "./HouseFundsPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2959e30b",
  null
  
)

export default component.exports